'use client';

import React from 'react';
import { AuthProvider } from '@/contexts/AuthContext';

type ProvidersProps = {
  children: React.ReactNode;
};

export default function Providers({ children }: ProvidersProps) {
  return <AuthProvider>{children}</AuthProvider>;
}
